import { CareTeamMember } from './CareTeamMember';
import { CareTeamMemberType } from './CareTeamMemberType';

export class CCMCareTeamMember extends CareTeamMember {
  subtype = '';

  constructor(obj: any) {
    super(obj);
    this.subtype = obj.subtype;
  }

  get typeWithSubType(): {
    type?: CareTeamMemberType;
    subtype?: string | undefined;
  } {
    return {
      type: this.type,
      subtype: this.subtype,
    };
  }
}

export default CCMCareTeamMember;
